/**
 * Nos Ateliers — met la vidéo du hero en pause si le mouvement est réduit.
 */
(function () {
  if (window.__lcfAteliersBound) return;
  window.__lcfAteliersBound = true;

  var motion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function sync() {
    document.querySelectorAll(".at2-hero__video, .at2-close__video").forEach(function (video) {
      if (motion.matches) {
        video.pause();
      } else if (video.paused) {
        var play = video.play();
        if (play && typeof play.catch === "function") play.catch(function () {});
      }
    });
  }

  if (typeof motion.addEventListener === "function") {
    motion.addEventListener("change", sync);
  }

  document.addEventListener("shopify:section:load", sync);
  sync();
})();
